/* ============================================================
   <quantity-bundle>
   Troca o produto real adicionado ao carrinho conforme a opção
   de quantidade selecionada. Atualiza o input [name=id] do
   product-form e sincroniza o bloco de preço principal.
   ============================================================ */
if (!customElements.get('quantity-bundle')) {
  customElements.define(
    'quantity-bundle',
    class QuantityBundle extends HTMLElement {
      connectedCallback() {
        this.sectionEl = this.closest('.shopify-section') || document;
        this.priceTarget = document.querySelector(
          this.getAttribute('data-price-target') || ''
        );
        this.inputs = Array.from(
          this.querySelectorAll('.qb-card__input')
        );

        this.inputs.forEach((input) => {
          input.addEventListener('change', () => this.onSelect(input));
        });

        // Sincroniza estado inicial com a opção marcada (garante que
        // form e preço batem com o card selecionado mesmo quando o
        // produto da PDP não está na lista do metacampo).
        const checked = this.inputs.find((i) => i.checked && !i.disabled);
        if (checked) this.onSelect(checked, true);
      }

      onSelect(input, isInitial) {
        if (input.disabled) return;

        const variantId = input.getAttribute('data-qb-variant-id');
        if (!variantId) return;

        // Estado visual
        this.querySelectorAll('.qb-card').forEach((card) =>
          card.classList.remove('is-selected')
        );
        const card = input.closest('.qb-card');
        if (card) card.classList.add('is-selected');

        this.updateFormVariant(variantId);
        this.updateButtonLabels(input.getAttribute('data-qb-qty-label'));
        this.updatePriceExtras(input);
        this.updateMainImage(input);

        // No load inicial não force re-render de preço se já bate,
        // mas sincroniza para garantir consistência visual.
        if (card) this.syncPrice(card);
      }

      updateButtonLabels(label) {
        this.updateAddButtonLabel(label);
        this.updateBuyNowButtonLabel(label);
      }

      updateAddButtonLabel(label) {
        const btn = this.sectionEl.querySelector('.product-form__submit');
        if (!btn) return;
        const span = btn.querySelector('span');
        if (!span) return;
        if (this.baseAddText == null) {
          this.baseAddText =
            (window.variantStrings && window.variantStrings.addToCart) ||
            span.textContent.trim();
        }
        span.textContent = label
          ? this.baseAddText + ' (' + label + ')'
          : this.baseAddText;
      }

      updateBuyNowButtonLabel(label, attempt = 0) {
        const buttons = this.sectionEl.querySelectorAll(
          '.shopify-payment-button__button--unbranded'
        );
        if (!buttons.length) {
          if (attempt < 10) {
            window.setTimeout(() => this.updateBuyNowButtonLabel(label, attempt + 1), 100);
          }
          return;
        }

        const text = label ? 'Comprar agora (' + label + ')' : 'Comprar agora';

        buttons.forEach((btn) => {
          btn.textContent = text;
          btn.setAttribute('aria-label', text);
        });
      }

      updateFormVariant(variantId) {
        const idInputs = this.sectionEl.querySelectorAll(
          'product-form [name="id"], .product-variant-id'
        );
        idInputs.forEach((el) => {
          el.value = variantId;
          el.removeAttribute('disabled');
        });
      }

      updatePriceExtras(input) {
        const priceCents = Number(input.getAttribute('data-qb-price-cents'));
        if (!Number.isFinite(priceCents) || priceCents <= 0) return;

        const sectionId = this.getAttribute('data-section-id');
        const extras =
          (sectionId && document.getElementById('VhPriceExtras-' + sectionId)) ||
          this.sectionEl.querySelector('[data-vh-price-extras]');
        if (!extras) return;

        const maxInstallments = Number(extras.dataset.maxInstallments || 0);
        const pixPct = Number(extras.dataset.pixPct || 0);

        if (maxInstallments > 1) {
          const installmentCents = Math.floor(priceCents / maxInstallments);
          const installmentLine = extras.querySelector('.vh-installments');
          if (installmentLine) {
            const prefix = extras.dataset.installmentsPrefix || 'ou';
            const suffix = extras.dataset.installmentsSuffix || 'sem juros';
            const strong = document.createElement('strong');
            strong.textContent =
              maxInstallments + 'x de ' + this.formatMoney(installmentCents, extras);

            installmentLine.textContent = '';
            installmentLine.append(
              document.createTextNode(prefix + ' '),
              strong,
              document.createTextNode(' ' + suffix)
            );
          }
        }

        if (pixPct > 0) {
          const pixFinalCents = priceCents - Math.floor((priceCents * pixPct) / 100);
          const pixAmount = extras.querySelector('.vh-pix-line__amount');
          if (pixAmount) pixAmount.textContent = this.formatMoney(pixFinalCents, extras);
        }
      }

      formatMoney(cents, context) {
        const currency = context.dataset.currency || 'BRL';
        const locale =
          context.dataset.locale ||
          document.documentElement.lang ||
          'pt-BR';

        try {
          return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency,
          })
            .format(cents / 100)
            .replace(/\u00a0/g, ' ');
        } catch (error) {
          return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
        }
      }

      syncPrice(card) {
        if (!this.priceTarget) return;
        const tpl = card.querySelector('template[data-qb-price-sync]');
        if (!tpl) return;
        this.priceTarget.innerHTML = tpl.innerHTML;
      }

      updateMainImage(input) {
        const imageSrc = input.getAttribute('data-qb-image-src');
        if (!imageSrc) return;

        const sectionId = this.getAttribute('data-section-id');
        const gallery = document.getElementById('MediaGallery-' + sectionId);
        if (!gallery) return;

        const activeSlide = gallery.querySelector('.product__media-item.is-active');
        if (!activeSlide) return;

        const img = activeSlide.querySelector('img');
        if (!img) return;

        const imageSrcset = input.getAttribute('data-qb-image-srcset');
        const imageAlt = input.getAttribute('data-qb-image-alt');

        img.setAttribute('src', imageSrc);
        if (imageSrcset) img.setAttribute('srcset', imageSrcset);
        if (imageAlt) img.setAttribute('alt', imageAlt);
      }
    }
  );
}
